module.exports = __webpack_public_path__ + "static/img/2018.08第七届创新创业大赛 优秀企业.2571c3c5.jpg";